import { createContext } from 'react';

const dcCalendarContext = createContext();
export default dcCalendarContext;
